import {
  renderShippingId,
  renderTags,
  renderAgendaTime,
  renderAgendaDate,
} from '../renderers';
import { ColumnConfig } from '@/components/table/Table';

export const preparePackageTableColumns: ColumnConfig[] = [
  {
    label: 'Pedido',
    field: 'shippingId',
    render: renderShippingId,
  },
  {
    label: 'Externo',
    field: 'externalId',
  },
  {
    label: 'Celular',
    field: 'phoneNumber',
  },
  {
    label: 'Fecha de agenda',
    field: 'dateAgenda',
    render: renderAgendaDate,
  },
  {
    label: 'Hora de agenda',
    field: 'hourAgenda',
    render: renderAgendaTime,
  },
  {
    label: 'Ubicación',
    field: 'shippingLocation',
  },
  {
    label: 'Tags',
    field: 'tags',
    render: renderTags,
  },
];
